import Axios from "axios";
import MainService from "./MainService";

export default class AccountabilityService extends MainService {
  constructor() {
		super();
		this.url = `${this.apiUrl}/accountabilities`;
  }

  saveAttachments(id, attachments) {
    return Axios.put(`${this.url}/${id}/attachments`, attachments);
  }

  saveExpense(id, expense) {
    return Axios.post(`${this.url}/${id}/expenses`, expense);
  }

  saveInvoice(id, invoice) {
    return Axios.put(`${this.url}/${id}/invoice`, invoice);
  }

  changeStatus(id, status) {
    return Axios.put(`${this.url}/${id}/status`, {}, {params: {status}});
  }
}



// WEBPACK FOOTER //
// ./src/service/AccountabilityService.js